<template>
  <form id="frm_action">
    <div class="p-formgrid row">
      <div class="col-lg-6">

        <div class="mt-2">
          <label class="txt-right required">Tên nhóm quyền</label>
          <InputText
            v-model="name"
            id="name"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
            :disabled="mode=='edit'"
          />
        </div>

        <div class="mt-3">
          <Checkbox id="is_farm" v-model="is_farm" :binary="true" />
          <label for="is_farm" class="m-0 ml-2" style="font-weight: normal">Dành cho trang trại</label>
        </div>

        <div v-if="is_farm==true" class="mt-3">
          <label class="txt-right required">Trang trại</label>
          <Dropdown 
            v-model="farm"
            :options="listFarm"
            optionLabel="name"
            placeholder="Chọn trang trại"/>
          <input class="input_tmp_validator" id="farm" />
        </div>

        <input class="input_tmp_validator" id="role" />
        
        <div class="position-relative mt-3">
          <div class="p-field p-grid box-permission" v-for="(item_c, index_c) in list_controller" :key="index_c">
            <div class="p-col-6 box-left permission-left">
              <div class="box span-label">{{ item_c.name }}</div>
            </div>
            <div class="p-col-6 box-right permission-right">
              
              <!-- cho 1 cấp -->
              <div class="row custom-lable div-checkbox">
                <div v-for="(roles_for, index_roles_for) in item_c.roles" :key="index_roles_for" class="d-flex col-12 align-items-center ml-3 mb-3 p-0">
                  <Checkbox :id="`checkbox-id-${roles_for.id}`" class="mr-2" v-model="checked[roles_for.id]" :binary="true"/>
                  <label :for="`checkbox-id-${roles_for.id}`" class="txt-right mb-0" style="font-weight: normal">{{roles_for.name}}</label>
                </div>
              </div>
            </div>
          </div>
          
          <div class="loading-controller" v-show="loading_controller">
            <div>
              <span class="fa fa-spinner fa-spin"></span>
              <span>Đang tải...</span>
            </div>
          </div>
        </div>
      
      </div>

      <Toolbar class="fixed-bottom-toolbar col-lg-12">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
          <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success main-style-button" />
          <Button
            v-else
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success main-style-button" />
        </template>
      </Toolbar>
    </div>
  </form>
</template>

<script>
import DataServices from "@/core/DataServices";
export default {
  props: {
    mode: String,
    model: Object,
  },
  data() {
    return {
      name: "",
      is_farm: false,
      farm: null,
      listFarm: [],
      list_controller: [],
      loading_controller: false,
      checked: {},
      is_saving : false,
    };
  },
  async mounted() {
    // console.log("this.model", this.model);
    await this.getListFarm();
    await this.getListController();
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.$commonFuction.is_loading(true);
      try {
        this.name = this.model.name;
        this.is_farm = this.model.is_farm;
        if (this.is_farm == true) {
          this.farm = this.listFarm.find(f => f.id == this.model.farm_id);
        }
        var roles = this.model.group_roles;
        roles.forEach((role) => {
          this.$set(this.checked, role.role_id, true);
        });
        this.$commonFuction.is_loading(false);
      } catch(err) {
        console.log("Errrr", err);
        this.$commonFuction.is_loading(false);
      }
    }
  },
  watch: {
  },
  methods: {
    backToList() {
      this.$emit("back");
    },

    async getListFarm() {
      var gqLQueryList = DataServices.getList("farm", {"fields": "id, name"});
      var where ={
        active: {_eq: true}
      }
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
          orderBy: {name: "asc"}
        }
      })
      var listData = resData.data["farm"];
      this.listFarm = listData;
    },

    async getListController(){
      this.loading_controller = true;
      var gqLQueryList = DataServices.getList("controller", {"fields": "id, name, is_parent, parent_id, roles{id, name}"});
      var where ={
        active: {_eq: true}
      }
      if (!this.is_saving){
        where = {
          active: {_eq: true},
          url: { _is_null: false, _neq: "" },
        }
      }
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
          orderBy: {ordinal: "desc"}
        }
      })
      var listData = resData.data["controller"];
      this.list_controller = listData;
      this.loading_controller = false;
    },

    async roleManagement() {
      this.is_saving = true;
      await this.getListController();

      let child_controller = this.list_controller.filter(ctrl => ctrl.parent_id != null);
      let parent_controller = this.list_controller.filter(ctrl => ctrl.is_parent === true);

      parent_controller.forEach(parent => {
        let parentRoleId = parent.roles[0].id.toString();
        if (this.checked[parentRoleId]) {
          // console.log("Removing parent role:", parentRoleId);
          this.$delete(this.checked, parentRoleId);
        }
      });

      child_controller.forEach(child => {
        let childRoleId = child.roles[0].id.toString();
        let parent = parent_controller.find(parent => parent.id === child.parent_id);

        if (parent) {
          let parentRoleId = parent.roles[0].id.toString();
          if (this.checked[childRoleId]) {
            if (!this.checked[parentRoleId]) {
              // console.log("Adding parent role:", parentRoleId);
              this.$set(this.checked, parentRoleId, true);
            }
          }
        }
      });

      // console.log("Final checked roles:", this.checked);
    },

    async validateData() {
      this.validationErrors = {};

      let name_add = document.getElementById("name");
      if (this.$commonFuction.isEmptyObject(this.name)) {
        name_add.setCustomValidity("Tên nhóm quyền không được để trống!");
      } else {
        name_add.setCustomValidity("");
      }

      if (this.is_farm == true) {
        let farm_add = document.getElementById("farm");
        if (this.$commonFuction.isEmptyObject(this.farm)) {
          farm_add.setCustomValidity("Trang trại không được để trống!");
        } else {
          farm_add.setCustomValidity("");
        }
      }

      var checked = [];
      // console.log(this.checked);
      var check_arr = Object.keys(this.checked);
      checked = check_arr.filter(f => this.checked[f]);

      let role_add = document.getElementById("role");
      if (checked.length < 1) {
        role_add.setCustomValidity("Vui lòng kích hoạt tối thiểu 1 nút tính năng để lưu nhóm quyền!");
      }else {
        role_add.setCustomValidity("");
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },

    async saveData() {
      
      this.$commonFuction.is_loading(true);
      
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      
      if (Object.entries(this.validationErrors).length !== 0) {
        this.$commonFuction.is_loading(false);
      
      }
      let farmID = null;
      if (this.is_farm == true) {
        farmID = this.farm.id;
      }
      let user_id = this.$store.getters.user;
      await this.roleManagement();
      var params = {
        name: this.name,
        is_farm: this.is_farm,
        farm_id: farmID,
        user_id: user_id,
        group_roles: Object.keys(this.checked).filter(f => this.checked[f])
      };
      // console.log("saveData", params);
      this.$emit("save", params);
      //this.$commonFuction.is_loading(false);
    },
  },
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 480px;
  height: 270px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.permission-left {
    border: 1px solid #D0D4D9;
    border-radius: 5px 0 0 5px;
    padding: 20px !important;
}
.permission-right {
    padding: 20px !important;
    border: 1px solid #D0D4D9;
    border-radius: 0 5px 5px 0;
    border-left: none;
}
.box-permission {
  margin: 10px 0;
}
.loading-controller {
  width: 100%;
  height: 100%;
  background-color: #0000006e;
  position: absolute;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.loading-controller span{
  margin: 0 5px;
  color: #fff;
  font-size: 15pt;
  font-weight: bold;
}
</style>
